import { useSelector } from "react-redux";
import { useForm } from "../hooks/useForm";
import { RootState } from "../store";
import Button from "./ui/Button";
import { Input } from "./ui/Input";
import { Label } from "./ui/Label";
import { useEffect } from "react";
import { useRetencionMutation } from "../services/docs";

import { toastr } from "react-redux-toastr";

export const RetencionComponent = () => {
  const { fi_llamada_id, fi_producto, SA_Importe } = useSelector(
    (state: RootState) => state.ui
  );
  const [retencionAction, { data, isError }] = useRetencionMutation();
  const { formulario, handleInputChange, handleChangeAll, handleTexareChange } =
    useForm({
      fi_llamada_id: fi_llamada_id,
      fi_downsell: 0,
      fc_suma: SA_Importe,
      fi_plan: +fi_producto,
      fc_comentarios: "",
    });
  useEffect(() => {
    if (SA_Importe !== formulario.fc_suma) {
      handleChangeAll({
        fi_downsell:
          formulario.fc_suma === "10000" && formulario.fc_suma !== SA_Importe
            ? 1
            : 0,
        fi_plan: +fi_producto === 1 ? 2 : 1,
      });
    } else {
      handleChangeAll({
        fi_downsell: 0,
        fi_plan: +fi_producto,
      });
    }
  }, [formulario.fc_suma]);

  const generarRetencion = async () => {
    console.log(formulario);
    if (formulario.fc_comentarios === "") {
      toastr.error("Debe agregar un comentario");
      return;
    }
    const resp = await retencionAction({
      ...formulario,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        }
        toastr.error(err.message);
        return;
      });
    if (resp) {
      toastr.success(resp.message);
    }
  };

  return (
    <div className="w-full">
      <h1 className="mb-10 rounded-t-xl border-b-2 border-primary py-2 pl-3 text-primary">
        Prueba Primero con Retención
      </h1>
      <div className="card w-full p-5">
        <h3 className="mb-5 font-bold">Retención</h3>
        <div className="my-5">
          <Label className="my-2" htmlFor="fc_nombre">
            Planes
          </Label>
          <Input
            type="text"
            disabled={true}
            value={formulario.fi_plan === 1 ? "Básico" : "Amplio"}
          />
        </div>
        <div className="my-5">
          <Label className="my-2" htmlFor="fc_nombre">
            Downsell:
          </Label>
          <Input
            type="text"
            disabled={true}
            value={formulario.fi_downsell === 0 ? "NO" : "SI"}
          />
        </div>
        <div className="my-5">
          <Label className="my-2" htmlFor="fc_nombre">
            Ajustar Suma asegurada
          </Label>
          <Label className="ml-5 text-lg font-bold">
            {" "}
            ${formulario.fc_suma}
          </Label>
          <Input
            type="range"
            value={formulario.fc_suma}
            onChange={handleInputChange}
            name="fc_suma"
            min="10000"
            max="15000"
            step="5000"
          />
        </div>
        <div className="my-5">
          <div className="alert alert-warning" role="alert">
            <strong>¡Alerta!</strong> La Suma Asegurada mínima es de $10,000.00
            y la máxima es de $15,000.00
          </div>
        </div>
        <div className="my-5">
          <Label htmlFor="fi_tipo_informacion" className="my-2">
            Comentarios:
          </Label>
          <textarea
            className="focus-visible:ring-ring flex h-12 w-full items-center justify-between rounded-xl border border-gray-light bg-gray-ultra-light px-3 py-2 text-base ring-primary-ultra-light file:border-0 file:bg-transparent file:text-sm placeholder:text-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2  disabled:cursor-not-allowed disabled:opacity-50"
            onChange={handleTexareChange}
            value={formulario.fc_comentarios}
            name="fc_comentarios"
            id=""
            cols={40}
            rows={2}
          ></textarea>
        </div>

        <div className="my-5">
          <Button onClick={generarRetencion}>Generar Retención</Button>
        </div>
      </div>
    </div>
  );
};
